import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";

import PickupFormComponent from "./component";

import { createPickup, createPickupImage } from "api/pickups";
import { previousStep } from "../pickup-form.actions";
import Tracking from "utils/tracking";
import { showToastError } from "../../../helpers";
import { toastActions } from "pickups-ui-library";

// const PickupFormComponent = () => <div>Pickup Form Component</div>

// Validation
/*
 *
 * Validate Form
 *
 * */
const validate = (values) => {
  const errors = {};

  if (values.pickupBlockId === "" || values.pickupBlockId === undefined) {
    errors.pickupBlockId = `You must specify a value or "other" for a pickup block`;
  }

  if (!values.pickupDate) {
    errors.pickupDate = `You must specify a value for the pickup date`;
  }

  return errors;
};
const submitPickup = (form) => (dispatch, getState) =>
  new Promise((reject, resolve) => {});

// Redux-Form forValueSelector
const selector = formValueSelector("NewPickup");

let initialValues = { statusId: "1", scheduleSourceId: "7" };

const mapStateToProps = (state, ownProps) => {
  initialValues = { ...initialValues, ...ownProps.initialValues };
  const passProps = {};
  return { initialValues, ...passProps };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { user, publicFormValues } = ownProps;

  const pickupLocation =
    (publicFormValues && publicFormValues.pickupLocation) ||
    ownProps.pickupLocation;
  const pickupBlock =
    (publicFormValues && publicFormValues.pickupBlock) || ownProps.pickupBlock;
  const handleSubmit = (form) => {
    const notes = [];
    if (form.notes) {
      notes.push({
        note: form.notes,
        noteCategoryId: 2,
      });
    }
    if (form.largeItemsNotes) {
      notes.push({
        note: form.largeItemsNotes,
        noteCategoryId: 5,
      });
    }
    const notesStringify = notes.length > 0 ? JSON.stringify(notes) : null;
    return new Promise((resolve, reject) => {
      let pickupData = {
        locationId: pickupLocation.id, // comes from location
        pickupDate: pickupBlock.date, // comes from the block
        statusId: 1,
        userId: user.id, // userId
        notes: notesStringify,
        pickupBlockId: pickupBlock.id,
        pickupTypeId: pickupBlock.zone.pickupTypeId,
        scheduleSourceId: 6,
        regionId: pickupBlock.regionId,
      };
      return createPickup(pickupData)
        .then((res) => {
          Tracking.track("Step 8: Logged: Pickup Scheduled Success");
          return res.data.data[0];
        })
        .then((pickup) =>
          Promise.all([
            pickup,
            ...publicFormValues.images.map(async (image) => {
              // Because we're storing object URLs and not the image data,
              // we need to "download" the image files before we can upload them.
              // This doesn't actually make a request out to the internet,
              // the browser handles it internally
              try {
                await createPickupImage(
                  pickup.id,
                  await (await fetch(image)).blob()
                );
                URL.revokeObjectURL(image);
              } catch (error) {
                if (!error.message.includes("timeout")) {
                  toastActions.showToast({
                    message: `Sorry, we couldn't upload your image(s)`,
                    type: "error",
                    // noClose: true,
                  });
                } else {
                  toastActions.showToast({
                    message: `Sorry, the image may take a few minutes to load`,
                    type: "info",
                    autoClose: 10000,
                    // noClose: true,
                  });
                }
              }
            }),
          ])
        )
        .then(([pickup]) => resolve(pickup))
        .catch((err) => {
          showToastError();
          reject(err);
        });
    });
  };

  return {
    previousStep: () => {
      dispatch(previousStep());
      // dispatch(resetFormData(['pickupBlock']))
    },
    onSubmit: (form) => handleSubmit(form),
  };
};

// Connect Redux Form
let PickupFormConnected = reduxForm({ form: "NewPickup", validate })(
  PickupFormComponent
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PickupFormConnected);
